import React from 'react';
import { UnitCard } from './UnitCard';
import { addYear, entryMatchesUnit } from '../../lib/helpers';

export function LevelSection({ level, apprenticeId, levelDates, evidence, signoffs, workplaceSignoffs, knowledgeUnits, profile, onSaveLevelDate, onToggleSignoff, onToggleWorkplace, onToggleKnowledge }) {
  const ld = levelDates.find(d => d.apprentice_id === apprenticeId && d.level_year === level.year);
  const startDate = ld?.start_date || '';
  const endDate = ld?.end_date || '';

  const canEdit = profile.role === 'trainer' || profile.role === 'employer';

  // Categorise units
  let completeCount = 0;
  let progressCount = 0;
  let notStartedCount = 0;

  level.units.forEach(u => {
    const es = signoffs.find(s => s.apprentice_id === apprenticeId && s.unit_code === u.code);
    const ws = workplaceSignoffs.find(s => s.apprentice_id === apprenticeId && s.unit_code === u.code);
    const ku = knowledgeUnits.find(k => k.apprentice_id === apprenticeId && k.unit_code === u.code);
    const approved = evidence.filter(e => e.apprentice_id === apprenticeId && entryMatchesUnit(e, u.code) && e.status === 'approved').length;

    const isComplete = !!es && !!ws && !!ku;
    const isInProgress = !!es || !!ws || !!ku || approved > 0;

    if (isComplete) completeCount++;
    else if (isInProgress) progressCount++;
    else notStartedCount++;
  });

  const total = level.units.length;
  const pctComplete = total > 0 ? Math.round((completeCount / total) * 100) : 0;
  const pctProgress = total > 0 ? Math.round((progressCount / total) * 100) : 0;

  function handleStartChange(val) {
    onSaveLevelDate(apprenticeId, level.year, 'start_date', val);
    if (val && !endDate) {
      onSaveLevelDate(apprenticeId, level.year, 'end_date', addYear(val));
    }
  }

  if (level.units.length === 0) return null;

  return (
    <div className="level-section">
      <div className="level-hdr">
        <span className="level-tag">{level.label}</span>

        {canEdit && (
          <div className="level-dates">
            <div className="level-date-grp">
              <span>Start:</span>
              <input type="date" value={startDate} onChange={e => handleStartChange(e.target.value)} />
            </div>
            <div className="level-date-grp">
              <span>End:</span>
              <input type="date" value={endDate} onChange={e => onSaveLevelDate(apprenticeId, level.year, 'end_date', e.target.value)} />
            </div>
          </div>
        )}

        <div className="level-progress">
          <div className="level-pct">{pctComplete}%</div>
          <div className="level-pct-lbl">{completeCount}/{total} units</div>
        </div>
      </div>

      {/* Segmented summary bar */}
      <div className="level-summary">
        <div className="level-seg-bar">
          {pctComplete > 0 && <div className="seg-complete" style={{ width: `${pctComplete}%` }} />}
          {pctProgress > 0 && <div className="seg-progress" style={{ width: `${pctProgress}%` }} />}
        </div>
        <div className="level-seg-legend">
          <span className="seg-label"><span className="seg-dot dot-complete" />{completeCount} complete</span>
          <span className="seg-label"><span className="seg-dot dot-progress" />{progressCount} in progress</span>
          <span className="seg-label"><span className="seg-dot dot-none" />{notStartedCount} not started</span>
        </div>
      </div>

      <div className="unit-grid">
        {level.units.map(u => (
          <UnitCard
            key={u.code}
            unit={u}
            apprenticeId={apprenticeId}
            evidence={evidence}
            signoffs={signoffs}
            workplaceSignoffs={workplaceSignoffs}
            knowledgeUnits={knowledgeUnits}
            profile={profile}
            onToggleSignoff={onToggleSignoff}
            onToggleWorkplace={onToggleWorkplace}
            onToggleKnowledge={onToggleKnowledge}
          />
        ))}
      </div>
    </div>
  );
}
